import { Link } from 'react-router-dom'
import classNames from '@ui-components-3/ui/lib/utils/classNames'

type OpenVisitProps = {
  pendingVisitId: string
  isOpenVisitButtonOutlined?: boolean
  isSuccess: boolean
}

const OpenVisit = ({ pendingVisitId, isOpenVisitButtonOutlined, isSuccess }: OpenVisitProps) => {
  return (
    <Link
      to={`/visits/${pendingVisitId}`}
      className={classNames('btn-small', isOpenVisitButtonOutlined ? 'btn-primary-outlined' : 'btn-primary')}
    >
      Open {isSuccess ? 'Session' : 'Visit'}
    </Link>
  )
}

export default OpenVisit
